module.exports = __webpack_public_path__ + "img/research-n-developent.2142918a.png";